import {
  generatePath as generateRoutePath,
  useParams as useRouterParams,
} from "react-router";

type PathParams<Path> = Path extends `:${infer Param}/${infer Rest}`
  ? Param | PathParams<Rest>
  : Path extends `:${infer Param}`
    ? Param
    : Path extends `${infer _Prefix}:${infer Rest}`
      ? PathParams<`:${Rest}`>
      : never;

type PathArgs<
  TPath,
  TParams = { [K in PathParams<TPath>]: string | number },
> = TParams;

export const routes = {
  tournaments: "/",
  myPage: "/min-sida/:memberId",
  reg: "/turneringar/:tournamentId",
  tournament: "/turneringar/:tournamentId/deltagare",
  tournamentGroup: "/turneringar/:tournamentId/deltagare/:groupId",
  myTournamentPage: "/turneringar/:tournamentId/min-sida/:memberId",
  team: "/turneringar/:tournamentId/lag/:teamId",
  regTeam: "/turneringar/:tournamentId/anmal-klubb/:memberId",
  createClub: "/turneringar/:tournamentId/skapa-klubb",
  addTeamLeader: "/turneringar/:tournamentId/lag/:teamId/ny-lagledare",
  addPlayer: "/turneringar/:tournamentId/lag/:teamId/ny-spelare",
} as const;

type Routes = typeof routes;
type RouteKey = keyof Routes;

export function useParams<TRouteKey extends RouteKey>() {
  return useRouterParams<PathParams<Routes[TRouteKey]>>();
}

export function generatePath<TRouteKey extends RouteKey>(
  route: TRouteKey,
  params: PathArgs<Routes[TRouteKey]>,
) {
  // @ts-ignore
  return generateRoutePath(routes[route], params);
}
